import SubHeaders from '@/components/Headers/SubHeaders'
import { QUERY_KEYS } from '@/constants/reactQueryKeys'
import { useConfirmation } from '@/contexts/confirmation'
import useDataGridRefetch from '@/hooks/useDataGridRefetch'
import { useMutationWithHandler } from '@/hooks/useMutationWithHandler'
import { useQueryWithHandler } from '@/hooks/useQueryWithHandler'
import { paths } from '@/utils/path'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useParams } from 'react-router-dom'
import { CV_SCREEN_RESULTS, FINAL_STATUS, useCvUrlClick } from '../../constants'
import { getCVByID, sendMail, updateCV } from '../../services'
import { Cv } from '../../types'
import CVDetailView from './CVDetailView'

const Update = () => {
    const { cvID } = useParams<{ cvID: string }>()
    const { t } = useTranslation()
    const { setConfirmation } = useConfirmation()
    const { handleCvUrlClick, isGettingPresignedUrl } = useCvUrlClick()
    const { refetchCurrent } = useDataGridRefetch({
        reactQueryKey: 'resume',
    })
    const [showDialogSendMailInterview, setShowDialogSendMailInterview] =
        useState<{
            show: boolean
            data: Record<string, any> | null
        }>({
            show: false,
            data: null,
        })
    const {
        data: cv,
        refetch,
        renderState,
    } = useQueryWithHandler({
        queryKey: [QUERY_KEYS.CV_DETAIL, cvID],
        queryFn: async () => {
            const result = await getCVByID(Number(cvID))
            return result
        },
    })
    const handleEdit = async (values: Cv) => {
        await updateCV({
            id: Number(cvID),
            cv: values,
        })
        refetchCurrent()
    }
    const { mutateAsync: updateCVMutation } = useMutationWithHandler(
        {
            mutationFn: handleEdit,
        },
        {
            reactQueryKeys: QUERY_KEYS.RESUMES,
            successMessage: t('updated-success'),
            onSuccess: () => {
                refetch()
            },
        }
    )
    const { mutateAsync: sendMailMutation } = useMutationWithHandler(
        {
            mutationFn: sendMail,
        },
        {
            reactQueryKeys: QUERY_KEYS.RESUMES,
            successMessage: t('send-mail-success'),
        }
    )
    const mailTemplate =
        CV_SCREEN_RESULTS?.find(
            (item) => item?.value === cv?.result?.cover_letter_screen_result
        )?.mail_template ||
        FINAL_STATUS?.find((item) => item?.value === cv?.result?.final_status)
            ?.mail_template

    const handleSendMail = async () => {
        if (!cv?.result?.id || !mailTemplate) {
            return
        }
        try {
            const mailSend = [
                ...(cv?.result?.mail_send || []),
                mailTemplate,
            ].filter((item): item is string => Boolean(item))
            await sendMailMutation({
                id: cv.result.id,
                mailTemplate: mailTemplate!,
                mail_send: mailSend,
            })
        } catch (error) {
            console.log('error: ', error)
        }
    }

    const stateComponent = renderState()
    if (stateComponent) return stateComponent
    const matchedStatus = FINAL_STATUS.find(
        (status) => status.value === cv?.result?.final_status
    )
    const matchedScreenResult = CV_SCREEN_RESULTS.find(
        (s) => s.value === cv?.result?.cover_letter_screen_result
    )

    // Nếu đang ở view mode, hiển thị CVDetailView
    return (
        <>
            <SubHeaders
                breadcrumbs={[
                    {
                        path: '/resume',
                        title: t('resume-list'),
                    },
                    {
                        path: `${paths.talentPoolManager}/${cv?.result?.id}`,
                        title: t('cv-information'),
                    },
                ]}
            />
            <CVDetailView
                cv={cv}
                handleCvUrlClick={handleCvUrlClick}
                isGettingPresignedUrl={isGettingPresignedUrl}
                matchedScreenResult={matchedScreenResult}
                matchedStatus={matchedStatus}
                mailTemplate={mailTemplate}
                setConfirmation={setConfirmation}
                handleSendMail={handleSendMail}
                setShowDialogSendMailInterview={setShowDialogSendMailInterview}
                showDialogSendMailInterview={showDialogSendMailInterview}
                refetch={refetch}
                updateCVMutation={updateCVMutation}
            />
        </>
    )
}

export default Update
